export default __webpack_public_path__ + "static/media/63d398aea0b42.8e930eb8.png";